import { useAccordionButton } from 'react-bootstrap';

export const CustomToggle = ({
  children,
  eventKey,
}: {
  children: React.ReactNode;
  eventKey: string;
}) => {
  const decoratedOnClick = useAccordionButton(eventKey);

  return (
    <button
      type="button"
      className="w-100 text-start bg-light p-2 border-0 rounded d-flex justify-content-between align-items-center"
      onClick={decoratedOnClick}
    >
      <strong className="text-primary">{children}</strong>
      <span className="accordion-icon">+</span>
    </button>
  );
};
